import React, {Component} from 'react';
import { cds } from '../../scripts/cds';
import FunctionContext from '../../contexts/FunctionContext';
import emitter from '../../scripts/eventEmitter';
import { trans } from '../../scripts/translate';
import { clear } from '@testing-library/user-event/dist/clear';

export class Coupon extends Component {
    static contextType = FunctionContext;

    constructor(props) {
        super(props);
        var position = localStorage.getItem('couponPosition');
        if (position) {
            position = JSON.parse(position);
        } else {
            position = { x: null, y: null };
        }
        this.state = {
            position: position,
            dragging: false,
            coupon: {
                bets: []
            },
            limits: {},
            played_coupon_id: 0,
            coupon_open: false,
            playing: false,
            in_coupon: {},
            constants: {},
            error: null,
            type: this.props.type || 'normal',
            amountError: false
        };
        this.dragStartX = 0;
        this.divRef = React.createRef();
        this.prices = [10, 20, 25, 50];
        this.update_timeout = null;
        this.playing_timeout = null;
    }

    setData = (data) => {

        // status?
        if (data.status === 'error') {
            this.setState({
                error: data.message
            }, () => {
                setTimeout(() => {
                    this.setState({ error: null });
                }, 3000);
            });
            return;
        }

        this.setState({
            coupon: data.coupon,
            limits: data.limits,
            constants: data.constants,
            playing: data.playing
        }, () => {
            if (data.playing) {
                clearTimeout(this.playing_timeout);
                this.playing_timeout = setTimeout(() => {
                    this.getPlayStatus();
                }, 3000);
                return;
            }
        });
        if (this.state.coupon_open && data.coupon.bets.length === 0) {
            this.setState({ coupon_open: false });
        }

        // bahisleri döndür
        if (data.coupon.bets.length > 0) {
            var in_coupon = {};
            data.coupon.bets.forEach(bet => {
                in_coupon[bet.event_id + '_' + bet.category_id + '_' + bet.option_id] = true;
            });
            this.setState({
                in_coupon: in_coupon
            })
        } else {
            this.setState({
                in_coupon: {}
            })
        }
    };

    addBet = (data) => {
        // kuponu getir
        cds('coupon/create-bet', {
            method: 'POST',
            body: data
        }).then(json => {
            this.setData(json);
        })

    };

    inCoupon = (event_id, category_id, option_id) => {
        return this.state.in_coupon[event_id + '_' + category_id + '_' + option_id] ? true : false;
    }

    componentDidMount() {
        // Div'in ilk pozisyonunu al ve state'e ata
        const divElement = this.divRef.current;
        const rect = divElement.getBoundingClientRect();
        this.setState({ position: { x: rect.left, y: rect.top } });

        // kuponu getir
        cds('coupon/get').then(json => {
            this.setData(json);
        });

      }

    handleMouseDown = (e) => {
        this.setState({ dragging: true });
        this.dragStartX = e.clientX - this.state.position.x;
      };
    
      handleMouseMove = (e) => {
        if (!this.state.dragging) return;
        this.setState({
            position: {
                x: e.clientX - this.dragStartX,
                y: this.state.position.y,
            }
        });
      };
    
      handleMouseUp = () => {
        this.setState({
            dragging: false
        }, () => {
            localStorage.setItem('couponPosition', JSON.stringify(this.state.position));
        });
      };

    getAmount() {
        return this.state.coupon.amount;
    }

    getTotalAmount() {
        var amount = this.getAmount();
        var colons = this.state.coupon.colons;
        if (colons < 1) colons = 1;
        return amount * colons;
    }

    setAmount(value) {
        this.setState({
            coupon: {
                ...this.state.coupon,
                amount: parseFloat(value)
            }
        });
    }

    checkAmount() {
        if (this.state.coupon.amount < this.state.limits.min) {
            this.setState({
                amountError: 'Minimum bahis miktarı ' + this.state.limits.min + ' TRY. Lütfen bahis miktarını arttırın.'
            });
            return;
        }
        if (this.state.coupon.amount > this.state.limits.max) {
            this.setState({
                amountError: 'Maksimum bahis miktarı ' + this.state.limits.max + ' TRY. Lütfen bahis miktarını azaltın.'
            });
            return;
        }
        this.setState({
            amountError: false
        }, () => {
            this.updateCoupon({ amount: this.state.coupon.amount });
        });
    }

    updateCoupon = (data) => {
        cds('coupon/update', {
            method: 'POST',
            body: data
        }).then(json => {
            this.setData(json);
        })
    }

    playCoupon = () => {
        this.setState({
            playing: true
        }, () => {
            cds('coupon/play', {
                method: 'POST',
                body: { amount: this.state.coupon.amount }
            }).then(json => {
                if (json == '505') {
                    clearTimeout(this.playing_timeout);
                    this.playing_timeout = setTimeout(() => {
                        this.getPlayStatus();
                    }, 3000);
                    return;
                }
                this.setData(json);
                this.setState({ 
                    playing: false,
                    played_coupon_id: json.played_coupon_id
                });
                emitter.emit('success', trans('Bahsiniz alınmıştır, iyi şanslar dileriz.'));
            })
        });
    }

    getPlayStatus = () => {
        cds('coupon/play-status', {
            method: 'POST',
            body: { played_coupon_id: this.state.played_coupon_id }
        }).then(json => {
            if (json.status === 'success') {
                if (json.completed === true) {
                    this.setData(json);
                    emitter.emit('success', trans('Bahsiniz alınmıştır, iyi şanslar dileriz.'));
                } else {
                    setTimeout(() => {
                        this.getPlayStatus();
                    }, 3000);
                }
            } else {
                emitter.emit('error', json.message);
            }
        });
    };

    deleteBet = (event_id, category_id, option_id) => {
        cds('coupon/delete-bet', {
            method: 'POST',
            body: { event_id: event_id, category_id: category_id, option_id: option_id }
        }).then(json => {
            this.setData(json);
        })
    }

    setSistem = (sistem) => {
        cds('coupon/system', {
            method: 'POST',
            body: { system: sistem }
        }).then(json => {
            this.setData(json);
        })
    }

    clearCoupon = () => {
        cds('coupon/clear').then(json => {
            this.setData(json);
        });
    }

    splitMe = () => {
        this.setState({
            type: this.state.type === 'cart' ? 'normal' : 'cart'
        })
    }
    
    render() {
        
        return (
            <React.Fragment>
                {this.state.type !== 'cart' ? this.props.children({ addBet: this.addBet, inCoupon: this.inCoupon }) : ''}
                {this.state.error ?
                <div className="flex flex-col fixed top-0 right-0 p-4 z-200 w-screen max-w-[400px]">
                    <div className="flex flex-col p-3 mb-2 text-gray-500 rounded-lg drop-shadow-xl backdrop-blur-lg backdrop-grayscale bg-slate-9/70" role="alert">
                        <div className="flex items-center">
                            <div className="inline-flex flex-shrink-0 justify-center items-center w-8 h-8 rounded-lg text-xl bg-red-500">
                                <div className="i-tabler-x text-secondary-100" onClick={() => this.setState({ error: null })}>
                                </div>
                            </div>
                            <p className="ml-3 mb-0 text-md font-normal text-secondary-100">{this.state.error}</p>
                        </div>
                    </div>
                </div>
                : ''}
                <>
                    <React.Fragment>
                        {this.state.type === 'cart' ? this.props.children({ addBet: this.addBet, inCoupon: this.inCoupon }) : ''}
                        {(React.createElement(
                            this.state.type === 'cart' ? 'aside' : 'div',
                            {
                                ref: this.divRef,
                                style: { left: this.state.position.x, opacity: this.state.coupon.bets.length > 0 || this.state.type === 'cart' ? '1' : '0' },
                                onMouseDown: this.handleMouseDown,
                                onMouseMove: this.handleMouseMove,
                                onMouseUp: this.handleMouseUp,
                                onMouseLeave: this.handleMouseUp,
                                className: this.state.type === 'cart' ? 'flex min-w-[330px] max-w-[330px] w-[330px] sticky top-14 overflow-y-auto justify-end' : 'fixed right-3 left-auto bottom-0 flex flex-col w-[350px] z-100 drop-shadow-2xl select-none animate-fade-in-up animate-duration-300 animate-ease'
                            },
                            <>
                                {this.state.type !== 'cart' ? this.state.coupon.bets.length === 0 ?
                                    <div className="bg-primary text-secondary-100 rounded-t px-5 py-3 cursor-pointer">
                                        {trans('Kupon Boş')}
                                    </div> : 
                                    <div className="bg-primary text-secondary-100 rounded-t px-5 py-3 cursor-pointer" onClick={() => this.setState({ coupon_open: !this.state.coupon_open })}>
                                        {this.state.coupon.bets.length} {trans(' Oran')} | {this.state.coupon.total_odd.toFixed(2)} x {this.state.coupon.amount.toFixed(2)} TRY = {this.state.coupon.max_gain.toFixed(2)} TRY
                                    </div>
                                : ''}
                                {this.state.type === 'cart' && this.state.coupon.bets.length === 0 ?
                                    <div className="flex flex-col w-full">
                                        <div className="flex z-50 w-full flex-col bg-secondary-100 dark:bg-secondary-dark-100 rounded mb-3 drop-shadow">
                                            <div className="flex flex-col justify-center text-center w-full h-28 py-6">
                                                <img className="m-auto" src={process.env.PUBLIC_URL + '/images/empty-tray-striped.svg'} alt="empty betslip" width="55" height="64" />
                                                <p className="text-center text-gray-7 px-20 leading-3">
                                                    <span className="text-sm">{trans('Sepetiniz Boş')}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <Talihliler />
                                    </div>
                                : ''}
                                <div className="overflow-y-scroll max-h-[600px]" style={{ display: (this.state.coupon_open || this.state.type === 'cart') && this.state.coupon.bets.length > 0 ? '' : 'none' }}>
                                    <div className="flex z-50 w-full flex-col bg-secondary-100 dark:bg-secondary-dark-100 drop-shadow">
                                        <ul className="flex w-full flex-col md:flex-row flex-wrap list-none border-b pl-0">
                                            <li className="w-2/4">
                                                <div className="nav-link flex flex-col font-semibold text-xs leading-tight border-x-0 border-t-0 border-b-2 border-transparent text-center py-2 hover:border-transparent focus:border-transparent text-secondary-500 active">
                                                    <span className="text-2xl">1</span>
                                                    <span>{trans('Kupon')}</span>
                                                </div>
                                            </li>
                                            <li className="w-2/4">
                                                <div className="nav-link flex flex-col font-semibold text-xs leading-tight border-x-0 border-t-0 border-b-2 border-transparent text-center py-2 hover:border-transparent focus:border-transparent text-secondary-500 active">
                                                    <span className="text-2xl">0</span>
                                                    <span>{trans('Aktif Bahisler')}</span>
                                                </div>
                                            </li>
                                        </ul>
                                        <div className="flex flex-col">
                                            <div className="flex w-full flex-row bg-secondary-200 dark:bg-secondary-dark-200 p-1.5">
                                                <div className="flex w-full items-center justify-between">
                                                    <div className="flex w-30">
                                                        <div className="relative w-full">
                                                            <select value={this.state.coupon.type} onChange={(e) => this.updateCoupon({ type: e.target.value })} className="appearance-none block w-full px-3 py-1.5 text-xs font-bold text-black-1 bg-secondary-100 dark:bg-secondary-dark-100 bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-secondary-100 dark:bg-secondary-dark-100 focus:outline-none focus:ring-0">
                                                                <option value={this.state.constants.COUPON_SINGLE}>{trans('Tekli')}</option>
                                                                <option value={this.state.constants.COUPON_COMBO}>{trans('Kombine')}</option>
                                                                {this.state.coupon.category < 2 &&<option value={this.state.constants.COUPON_SYSTEM}>{trans('Sistem')}</option>}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-row items-center">
                                                        <div className="w-5 h-5 mr-1 cursor-pointer" onClick={() => this.splitMe()}>
                                                            {this.state.type === 'cart' ? 
                                                                <svg xmlns="http://www.w3.org/2000/svg" className="fill-secondary-500" viewBox="0 0 24 24" fill="none"><path d="M2 18C2 16.1144 2 15.1716 2.58579 14.5858C3.17157 14 4.11438 14 6 14C7.88562 14 8.82843 14 9.41421 14.5858C10 15.1716 10 16.1144 10 18C10 19.8856 10 20.8284 9.41421 21.4142C8.82843 22 7.88562 22 6 22C4.11438 22 3.17157 22 2.58579 21.4142C2 20.8284 2 19.8856 2 18Z"></path><path fillRule="evenodd" clipRule="evenodd" d="M3.46447 3.46447C2 4.92893 2 7.28595 2 12C2 12.3956 2 12.7746 2.00087 13.1378C2.50896 12.8047 3.06882 12.6588 3.6056 12.5866C4.25122 12.4998 5.04488 12.4999 5.91052 12.5H6.08951C6.95514 12.4999 7.74881 12.4998 8.39443 12.5866C9.10539 12.6822 9.85684 12.9071 10.4749 13.5251C11.0929 14.1432 11.3178 14.8946 11.4134 15.6056C11.5002 16.2512 11.5001 17.0449 11.5 17.9105V18.0895C11.5001 18.9552 11.5002 19.7488 11.4134 20.3944C11.3412 20.9312 11.1954 21.491 10.8622 21.9991C11.2255 22 11.6044 22 12 22C16.714 22 19.0711 22 20.5355 20.5355C22 19.0711 22 16.714 22 12C22 7.28595 22 4.92893 20.5355 3.46447C19.0711 2 16.714 2 12 2C7.28595 2 4.92893 2 3.46447 3.46447ZM13.25 6.25C12.8358 6.25 12.5 6.58579 12.5 7C12.5 7.41421 12.8358 7.75 13.25 7.75H15.1893L11.4697 11.4697C11.1768 11.7626 11.1768 12.2374 11.4697 12.5303C11.7626 12.8232 12.2374 12.8232 12.5303 12.5303L16.25 8.81066V10.75C16.25 11.1642 16.5858 11.5 17 11.5C17.4142 11.5 17.75 11.1642 17.75 10.75V7C17.75 6.58579 17.4142 6.25 17 6.25H13.25Z"></path></svg>
                                                            :
                                                                <svg xmlns="http://www.w3.org/2000/svg" className="fill-[#717171]" viewBox="0 0 24 24" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M11.6591 2.75C11.6591 3.16421 11.3233 3.5 10.9091 3.5H10C9.5638 3.5 9.1653 3.50001 8.79757 3.50318C8.38337 3.50675 8.0447 3.17387 8.04112 2.75968C8.03755 2.34548 8.37043 2.00681 8.78463 2.00323C9.15945 2 9.56404 2 9.99785 2L10.9091 2C11.3233 2 11.6591 2.33579 11.6591 2.75ZM11.6591 20.75C11.6591 21.1642 11.3233 21.5 10.9091 21.5H9.9977C9.56395 21.5 9.15941 21.5 8.78463 21.4968C8.37043 21.4932 8.03755 21.1545 8.04112 20.7403C8.0447 20.3261 8.38337 19.9932 8.79757 19.9968C9.1653 20 9.56379 20 10 20H10.9091C11.3233 20 11.6591 20.3358 11.6591 20.75ZM6.62882 2.8046C6.75175 3.20015 6.53075 3.62047 6.1352 3.7434C5.81401 3.84322 5.59048 3.97754 5.40901 4.15901C5.22754 4.34048 5.09322 4.56401 4.9934 4.8852C4.87047 5.28075 4.45015 5.50175 4.0546 5.37882C3.65905 5.25589 3.43805 4.83557 3.56098 4.44002C3.72116 3.92463 3.96876 3.47794 4.34835 3.09835C4.72794 2.71876 5.17463 2.47116 5.69002 2.31098C6.08558 2.18805 6.50589 2.40905 6.62882 2.8046ZM6.62882 20.6954C6.50589 21.091 6.08557 21.312 5.69002 21.189C5.17463 21.0288 4.72794 20.7812 4.34835 20.4017C3.96876 20.0221 3.72116 19.5754 3.56098 19.06C3.43805 18.6644 3.65905 18.2441 4.0546 18.1212C4.45015 17.9983 4.87047 18.2193 4.9934 18.6148C5.09322 18.936 5.22754 19.1595 5.40901 19.341C5.59048 19.5225 5.81401 19.6568 6.1352 19.7566C6.53075 19.8795 6.75175 20.2998 6.62882 20.6954ZM4.00968 6.79112C4.42387 6.7947 4.75675 7.13337 4.75318 7.54756C4.75001 7.9153 4.75 8.31379 4.75 8.75V10.1136C4.75 10.5278 4.41421 10.8636 4 10.8636C3.58579 10.8636 3.25 10.5278 3.25 10.1136L3.25 8.7477C3.25 8.31395 3.25 7.90941 3.25324 7.53462C3.25681 7.12043 3.59548 6.78755 4.00968 6.79112ZM4.00967 16.7089C3.59548 16.7125 3.25681 16.3796 3.25323 15.9654C3.25 15.5906 3.25 15.186 3.25 14.7523L3.25 13.3864C3.25 12.9722 3.58579 12.6364 4 12.6364C4.41421 12.6364 4.75 12.9721 4.75 13.3864L4.75 14.75C4.75 15.1862 4.75001 15.5847 4.75318 15.9524C4.75675 16.3666 4.42387 16.7053 4.00967 16.7089Z"></path><path d="M22 12.75V10.75C22 6.97876 22 5.09315 20.8284 3.92157C19.7358 2.82894 17.1523 2.75532 13.75 2.75036C13.75 2.33614 13.4142 2 13 2C12.5858 2 12.25 2.33579 12.25 2.75L12.25 20.75C12.25 21.1642 12.5858 21.5 13 21.5C13.4142 21.5 13.75 21.1642 13.75 20.75C17.1523 20.745 19.7358 20.6711 20.8284 19.5784C22 18.4069 22 16.5212 22 12.75Z"></path></svg>
                                                            }
                                                        </div>
                                                        <div className="w-5 h-5 mr-1 cursor-pointer">
                                                            <img className="m-auto" src={process.env.PUBLIC_URL + '/images/delete-icon.svg'} alt="clear betslip" onClick={() => this.clearCoupon()} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-col bg-secondary-100 dark:bg-secondary-dark-100">
                                                {this.state.coupon.bets.map((bet) => (
                                                    <div key={bet.event_id} className="flex w-full flex-row border-b transition-all ease-in-out duration-150">
                                                        <div className="flex flex-col grow px-1.5 py-2.5 pl-3">
                                                            <div className="text-base1 text-black-1">
                                                                <span className="whitespace-nowrap pr-1">{bet.category_name}:</span>
                                                                <span className="whitespace-nowrap font-semibold">{bet.option_name}</span>
                                                            </div>
                                                            <div className="flex justify-between items-center mt-2">
                                                                <div className="flex flex-col grow">
                                                                    <div className="flex text-xs1 text-secondary-500">{bet.event_name}</div>
                                                                    <div className="text-xs">{bet.play_score === '-' ? '0:0' : bet.play_score} | {bet.play_time}' </div>
                                                                </div>
                                                                <div className="px-3 py-1 bg-secondary-200 dark:bg-secondary-dark-200 text-black-1 rounded text-sm transition-all ease-in-out duration-150">
                                                                    {bet.odd.toFixed(2)}
                                                                </div>
                                                                <div className="flex items-center cursor-pointer mx-2.5">
                                                                    <img src={process.env.PUBLIC_URL + '/images/close.svg'} alt="Bahsi Sil" className="w-2.5 h-2.5" onClick={() => this.deleteBet(bet.event_id, bet.category_id, bet.option_id)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="flex flex-row bg-secondary-100 dark:bg-secondary-dark-100 text-base1 px-3 py-1.5">
                                                <span className="grow">{trans('Toplam Oran')}</span>
                                                <span className="font-semibold">{parseFloat(this.state.coupon.total_odd).toFixed(2)}</span>
                                            </div>
                                            <div className="flex flex-row bg-secondary-100 dark:bg-secondary-dark-100 text-base1 px-3 py-1.5">
                                                <span className="grow">{trans('Bahis Limiti')}</span>
                                                <span className="font-semibold">{parseFloat(this.state.limits.min).toFixed(2)} - {parseFloat(this.state.limits.max).toFixed(2)} TRY</span>
                                            </div>
                                            {this.state.coupon.type === this.state.constants.COUPON_SYSTEM ?
                                            <div className="flex flex-col items-start bg-secondary-200">
                                                <div className="flex flex-col bg-secondary-100 dark:bg-secondary-dark-100 gap-3 mt-2 p-3 w-full">
                                                    <div className="text-base1">{trans('Sistem Seçimi')}</div>
                                                    <div className="flex justify-start gap-3 flex-wrap">
                                                        {this.state.coupon.system_options?.map((system) => (
                                                            <div className="flex justify-start items-center w-1/4" key={system}>
                                                                <input id={'system_'+system} checked={this.state.coupon.sistem.indexOf(system) !== -1 ? true : false} onChange={() => this.setSistem(system)} type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                                                <label for={'system_'+system} className="ms-2 text-sm font-medium text-gray-900">{system}/{this.state.coupon.bets.length}</label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            : ''}
                                            {/*<div className="flex flex-row bg-primary text-secondary-100 text-xs px-3 py-1.5">
                                                <span>Sepetinize 3 bahis daha ekleyin ve Camila Cabello'yu kazanın.</span>
                                            </div>*/}
                                            {this.state.amountError &&
                                            <div class="flex flex-row items-start bg-secondary-200 dark:bg-secondary-dark-200 text-base1 p-3 pt-5">
                                                <img class="m-auto w-5 h-5" src={process.env.PUBLIC_URL + '/images/alert.svg'} alt="empty betslip" />
                                                <span class="text-xs1 text-red-down leading-4 font-normal pl-2">{this.state.amountError}</span>
                                            </div>}
                                            <div className="flex flex-col items-start bg-secondary-200 dark:bg-secondary-dark-200 p-3 rounded-b">
                                                <div className="flex flex-row w-full">
                                                    <div className="flex flex-col w-2/4 bg-secondary-100 dark:bg-secondary-dark-100 border rounded mr-2 py-1 px-2">
                                                        <div className="flex flex-row items-center text-lg1">
                                                            <span className="text-gray-7 pr-0">{this.state.coupon.colons ? this.state.coupon.colons : 1 }x</span>
                                                            <div className="flex">
                                                                <input type="number" className="rounded-none rounded-l-lg bg-secondary-100 dark:bg-secondary-dark-100 border-none text-black-1 font-bold focus:ring-none block flex-1 min-w-0 w-full text-lg1 border-gray-300 p-1" 
                                                                    value={this.getAmount()} onChange={(e) => this.setAmount(e.target.value)} onBlur={() => this.checkAmount()} />
                                                                <span className="inline-flex items-center px-1 text-sm text-gray-900 border-none border-l-0 rounded-r-md">
                                                                    <span className="text-lg1 text-black-1 font-bold">TRY</span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <span className="text-xs1 text-gray-light">{trans('Bahis Başına Miktar')}</span>
                                                    </div>
                                                    <div className="flex flex-col w-2/4 bg-secondary-100 dark:bg-secondary-dark-100 border rounded mr-2 py-1 px-2 select-none">
                                                        <div className="flex flex-row items-center text-lg1">
                                                            <div className="flex">
                                                                <span type="number" className="rounded-none rounded-l-lg bg-secondary-100 dark:bg-secondary-dark-100 border-none text-black-1 font-bold focus:ring-none block flex-1 min-w-0 w-full text-lg1 border-gray-300 p-1">
                                                                    {this.getTotalAmount()}
                                                                </span>
                                                                <span className="inline-flex items-center px-1 text-sm text-gray-900 border-none border-l-0 rounded-r-md">
                                                                    <span className="text-lg1 text-black-1 font-bold">TRY</span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <span className="text-xs1 text-gray-light">{trans('Toplam Miktar')}</span>
                                                    </div>
                                                </div>
                                                <div className="flex flex-col w-full py-2.5 px-2">
                                                    <span className="flex text-lg1 font-bold text-green-dark justify-end">{parseFloat(this.state.coupon.max_gain).toFixed(2)} TRY</span>
                                                    <span className="flex text-xs1 text-gray-light justify-end">{trans('Muhtemel Kazanç')}</span>
                                                </div>
                                                <div className="flex flex-row w-full justify-between py-2.5">
                                                    {this.prices.map((price) => (
                                                        <button key={price} type="button" onClick={() => this.updateCoupon({ amount: price })} className="inline-block px-5 py-2 bg-secondary-100 dark:bg-secondary-dark-100 text-black-1 font-semibold text-lg1 leading-tight rounded drop-shadow hover:drop-shadow focus:bg-green-1 focus:text-secondary-100 focus:drop-shadow focus:outline-none focus:ring-0 active:bg-green-1 active:drop-shadow transition duration-150 ease-in-out">{price}</button>
                                                    ))}
                                                </div>
                                                <div className="flex w-full space-x-2 justify-center">
                                                    <button onClick={() => this.playCoupon()} type="button" 
                                                        className={(this.state.playing || this.state.amountError ? 'bg-slate-9 opacity-50 ' : '') + 'w-full inline-block px-6 py-3.5 bg-primary text-secondary-100 font-medium text-base leading-tight rounded drop-shadow hover:bg-primary hover:drop-shadow focus:bg-primary focus:drop-shadow focus:outline-none focus:ring-0 active:bg-primary active:drop-shadow transition duration-150 ease-in-out'}
                                                        disabled={this.state.playing || this.state.amountError ? true : false}>
                                                        <div className="flex justify-center items-center gap-3">
                                                            {this.state.playing ? <span><svg aria-hidden="true" className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-primary" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path></svg></span> : ''}
                                                            <span>{trans('Bahis Yap')}</span>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}
                    </React.Fragment>
                </>
            </React.Fragment>
        );
    }
}

function Talihliler() {
    return (
        <div className="flex z-10 w-full flex-col">
            <span className="text-base1 text-black-1 font-semibold uppercase px-4 pb-2 pt-1">{trans('Haftanın Talihlileri')}</span>
            <div className="flex w-full flex-col bg-secondary-100 dark:bg-secondary-dark-100 rounded mb-3 drop-shadow">
                <div className="flex bg-secondary-200 dark:bg-secondary-dark-200 text-gray-7 py-3">
                    <div className="w-2/5 text-center text-xs1">{trans('Oyuncu')}</div>
                    <div className="w-3/5 text-center text-xs1">{trans('Miktar')}</div>
                </div>
                <div>
                    <div className="bg-secondary-100 dark:bg-secondary-dark-100">
                        <h2 className="mb-0">
                            <button
                                className="relative flex items-center w-full py-2.5 px-3 text-base1 text-black-1 text-left font-semibold bg-secondary-100 dark:bg-secondary-dark-100 border-0 rounded-none transition hover:bg-gray-300 focus:outline-none"
                                type="button">
                                <div className="flex flex-row w-2/5 text-center">
                                    <div className="w-1/4">1.</div>
                                    <div className="w-3/4">N8***7</div>
                                </div>
                                <div className="w-3/5 text-right pr-3 font-medium">41750 TRY</div>
                            </button>
                        </h2>
                        <div style={{ display: 'none' }}>
                            <div>
                                <div
                                    className="flex flex-col w-full bg-secondary-200 dark:bg-secondary-dark-200 border-b py-2 px-4">
                                    <div className="flex flex-col text-base1 leading-5 animate-pulse"><span
                                            className="flex h-2.5 bg-gray-300 rounded-full w-24 mb-1"></span><span
                                            className="h-2 bg-gray-300 rounded-full w-40 mb-1"></span></div>
                                </div>
                                <div className="flex flex-col w-full bg-secondary-200 dark:bg-secondary-dark-200border-b py-2 px-4">
                                    <div className="flex flex-col text-base1 leading-5 animate-pulse"><span
                                            className="h-2.5 bg-gray-300 rounded-full w-28 mb-1"></span><span
                                            className="h-2 bg-gray-300 rounded-full w-35"></span></div>
                                </div>
                            </div>
                            <div className="flex flex-row w-full justify-between bg-secondary-200 dark:bg-secondary-dark-200 border-b py-2 px-4"
                                style={{ display: 'none' }}>
                                <div className="flex flex-row text-base1"><span>Tekli - Bahis</span></div>
                                <div className="flex flex-row text-lg1 font-semibold"><span>Oran: </span></div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-secondary-100 dark:bg-secondary-dark-100">
                        <h2 className="mb-0"><button
                                className="relative flex items-center w-full py-2.5 px-3 text-base1 text-black-1 text-left font-semibold bg-secondary-100 dark:bg-secondary-dark-100 border-0 rounded-none transition hover:bg-gray-300 focus:outline-none"
                                type="button">
                                <div className="flex flex-row w-2/5 text-center">
                                    <div className="w-1/4">2.</div>
                                    <div className="w-3/4">F4***1</div>
                                </div>
                                <div className="w-3/5 text-right pr-3 font-medium">42651 TRY</div>
                            </button></h2>
                        <div style={{ display: 'none' }}>
                            <div>
                                <div
                                    className="flex flex-col w-full bg-secondary-200 dark:bg-secondary-dark-200 border-b py-2 px-4">
                                    <div className="flex flex-col text-base1 leading-5 animate-pulse"><span
                                            className="flex h-2.5 bg-gray-300 rounded-full w-24 mb-1"></span><span
                                            className="h-2 bg-gray-300 rounded-full w-40 mb-1"></span></div>
                                </div>
                                <div className="flex flex-col w-full bg-secondary-200 dark:bg-secondary-dark-200border-b py-2 px-4">
                                    <div className="flex flex-col text-base1 leading-5 animate-pulse"><span
                                            className="h-2.5 bg-gray-300 rounded-full w-28 mb-1"></span><span
                                            className="h-2 bg-gray-300 rounded-full w-35"></span></div>
                                </div>
                            </div>
                            <div className="flex flex-row w-full justify-between bg-secondary-200 dark:bg-secondary-dark-200 border-b py-2 px-4"
                                style={{ display: 'none' }}>
                                <div className="flex flex-row text-base1"><span>Tekli - Bahis</span></div>
                                <div className="flex flex-row text-lg1 font-semibold"><span>Oran: </span></div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-secondary-100 dark:bg-secondary-dark-100">
                        <h2 className="mb-0"><button
                                className="relative flex items-center w-full py-2.5 px-3 text-base1 text-black-1 text-left font-semibold bg-secondary-100 dark:bg-secondary-dark-100 border-0 rounded-none transition hover:bg-gray-300 focus:outline-none"
                                type="button">
                                <div className="flex flex-row w-2/5 text-center">
                                    <div className="w-1/4">3.</div>
                                    <div className="w-3/4">T0***3</div>
                                </div>
                                <div className="w-3/5 text-right pr-3 font-medium">46398 TRY</div>
                            </button></h2>
                        <div style={{ display: 'none' }}>
                            <div>
                                <div
                                    className="flex flex-col w-full bg-secondary-200 dark:bg-secondary-dark-200 border-b py-2 px-4">
                                    <div className="flex flex-col text-base1 leading-5 animate-pulse"><span
                                            className="flex h-2.5 bg-gray-300 rounded-full w-24 mb-1"></span><span
                                            className="h-2 bg-gray-300 rounded-full w-40 mb-1"></span></div>
                                </div>
                                <div className="flex flex-col w-full bg-secondary-200 dark:bg-secondary-dark-200border-b py-2 px-4">
                                    <div className="flex flex-col text-base1 leading-5 animate-pulse"><span
                                            className="h-2.5 bg-gray-300 rounded-full w-28 mb-1"></span><span
                                            className="h-2 bg-gray-300 rounded-full w-35"></span></div>
                                </div>
                            </div>
                            <div className="flex flex-row w-full justify-between bg-secondary-200 dark:bg-secondary-dark-200 border-b py-2 px-4"
                                style={{ display: 'none' }}>
                                <div className="flex flex-row text-base1"><span>Tekli - Bahis</span></div>
                                <div className="flex flex-row text-lg1 font-semibold"><span>Oran: </span></div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-secondary-100 dark:bg-secondary-dark-100">
                        <h2 className="mb-0"><button
                                className="relative flex items-center w-full py-2.5 px-3 text-base1 text-black-1 text-left font-semibold bg-secondary-100 dark:bg-secondary-dark-100 border-0 rounded-none transition hover:bg-gray-300 focus:outline-none"
                                type="button">
                                <div className="flex flex-row w-2/5 text-center">
                                    <div className="w-1/4">4.</div>
                                    <div className="w-3/4">T0***3</div>
                                </div>
                                <div className="w-3/5 text-right pr-3 font-medium">46398 TRY</div>
                            </button></h2>
                        <div style={{ display: 'none' }}>
                            <div>
                                <div
                                    className="flex flex-col w-full bg-secondary-200 dark:bg-secondary-dark-200 border-b py-2 px-4">
                                    <div className="flex flex-col text-base1 leading-5 animate-pulse"><span
                                            className="flex h-2.5 bg-gray-300 rounded-full w-24 mb-1"></span><span
                                            className="h-2 bg-gray-300 rounded-full w-40 mb-1"></span></div>
                                </div>
                                <div className="flex flex-col w-full bg-secondary-200 dark:bg-secondary-dark-200border-b py-2 px-4">
                                    <div className="flex flex-col text-base1 leading-5 animate-pulse"><span
                                            className="h-2.5 bg-gray-300 rounded-full w-28 mb-1"></span><span
                                            className="h-2 bg-gray-300 rounded-full w-35"></span></div>
                                </div>
                            </div>
                            <div className="flex flex-row w-full justify-between bg-secondary-200 dark:bg-secondary-dark-200 border-b py-2 px-4"
                                style={{ display: 'none' }}>
                                <div className="flex flex-row text-base1"><span>Tekli - Bahis</span></div>
                                <div className="flex flex-row text-lg1 font-semibold"><span>Oran: </span></div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-secondary-100 dark:bg-secondary-dark-100">
                        <h2 className="mb-0"><button
                                className="relative flex items-center w-full py-2.5 px-3 text-base1 text-black-1 text-left font-semibold bg-secondary-100 dark:bg-secondary-dark-100 border-0 rounded-none transition hover:bg-gray-300 focus:outline-none"
                                type="button">
                                <div className="flex flex-row w-2/5 text-center">
                                    <div className="w-1/4">5.</div>
                                    <div className="w-3/4">Y0***6</div>
                                </div>
                                <div className="w-3/5 text-right pr-3 font-medium">57874.74 TRY</div>
                            </button></h2>
                        <div style={{ display: 'none' }}>
                            <div>
                                <div
                                    className="flex flex-col w-full bg-secondary-200 dark:bg-secondary-dark-200 border-b py-2 px-4">
                                    <div className="flex flex-col text-base1 leading-5 animate-pulse"><span
                                            className="flex h-2.5 bg-gray-300 rounded-full w-24 mb-1"></span><span
                                            className="h-2 bg-gray-300 rounded-full w-40 mb-1"></span></div>
                                </div>
                                <div className="flex flex-col w-full bg-secondary-200 dark:bg-secondary-dark-200border-b py-2 px-4">
                                    <div className="flex flex-col text-base1 leading-5 animate-pulse"><span
                                            className="h-2.5 bg-gray-300 rounded-full w-28 mb-1"></span><span
                                            className="h-2 bg-gray-300 rounded-full w-35"></span></div>
                                </div>
                            </div>
                            <div className="flex flex-row w-full justify-between bg-secondary-200 dark:bg-secondary-dark-200 border-b py-2 px-4"
                                style={{ display: 'none' }}>
                                <div className="flex flex-row text-base1"><span>Tekli - Bahis</span></div>
                                <div className="flex flex-row text-lg1 font-semibold"><span>Oran: </span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Coupon;